import { render, staticRenderFns } from "./posterList.vue?vue&type=template&id=9dee584a&"
import script from "./posterList.vue?vue&type=script&lang=js&"
export * from "./posterList.vue?vue&type=script&lang=js&"
import style0 from "./posterList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports